import { FC, ReactElement } from 'react';
import { t } from 'i18next';
// components
import { Popover, Whisper } from 'rsuite';
// utils && hooks
import { STATUS_ICON } from '../../utils';
// styles
import styles from './AgreementsMenu.module.css';

interface AgreementsMenuProps {
    children: ReactElement;
    data: any;
}

const AgreementsMenu: FC<AgreementsMenuProps> = ({ data, children }) => {
    return (
        <Whisper
            placement="bottom"
            speaker={
                <Popover className={styles['popover']}>
                    {data.map(({ type: { id: typeId }, status: { id }, filename }, index) => {
                        return (
                            <div className={styles['item']}>
                                {STATUS_ICON[id]}
                                <p>
                                    {typeId === 1
                                        ? t('settings.commercialAgreements.sett_labelAllProductsMedCheckbox')
                                        : typeId === 2
                                        ? t('settings.commercialAgreements.sett_labelAllProductsNoMedCheckbox')
                                        : typeId === 3
                                        ? filename
                                        : typeId === 4
                                        ? t('listAgreements.product.refrigerated')
                                        : ''}
                                </p>
                            </div>
                        );
                    })}
                </Popover>
            }
        >
            {children}
        </Whisper>
    );
};

export default AgreementsMenu;
